import { isEmpty } from "lodash";
import React from "react";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { domainListAtom } from "../../containers/App/App.state";
import { getDomain } from "../../helpers/services/ContractServices";
import DomainTable from "./DomainTable";
import { makeStyles } from "@material-ui/core/styles";

const useDomainListStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}));

const DomainList = (props) => {
  const classes = useDomainListStyles();
  const [{ trader_company_id, domains }, setDomains] =
    useRecoilState(domainListAtom);

  const { isLoading, data } = useQuery({
    queryKey: ["Domain", props.trader_company_id],
    queryFn: () => getDomain(props.trader_company_id),
    onSuccess: (data) => {
      if (isEmpty(domains) || props.trader_company_id !== trader_company_id) {
        setDomains({
          trader_company_id: props.trader_company_id,
          domains: data,
        });
      }
    },
    enabled: Boolean(props.trader_company_id),
  });

  return (
    <div className={classes.root}>
      <DomainTable
        trader_company_id={props.trader_company_id}
        status={props.status}
      />
    </div>
  );
};

export default DomainList;
